import React from 'react';
import './addressChangePane.module.scss';
import { observer, inject } from 'mobx-react';
import { HomePageState } from '../../../containers/home/states/HomePageState';
import { observable, makeObservable } from 'mobx';
import { GlobalLoader } from '../../../../mainv2/components/GlobalLoader';
import { NotFoundPage } from '../../../../mainv2/containers/common/NotFoundPage';
import { UserAddressForm, UserAddressSummary } from '../../molecules/applications/UserAddressForm';
import { AddressChangePaneState } from './states/AddressChangePaneState';
import { SummaryBody } from '../../molecules/applications/base';
import { SettingPane } from '../../molecules/mypage/page';
import { Alert, AlertContent } from '@sheinc/shelikes-design-system';

type Props = {
  homeState: HomePageState;
};

export const AddressChangePane = inject('homeState')(
  observer(
    class AddressChangePane extends React.Component<Props> {
      pageState = new AddressChangePaneState();

      constructor(props: Props) {
        super(props);

        makeObservable(this, {
          pageState: observable,
        });
      }

      componentDidMount(): void {
        this.pageState.init();
      }

      render() {
        const { addressFormState, currentAddress, submitting, submit } = this.pageState;
        if (currentAddress.loading) {
          return <GlobalLoader />;
        }
        if (currentAddress.isNotFound()) {
          return <NotFoundPage />;
        }
        return (
          <SettingPane activeMenu="address" title="住所の確認">
            {!currentAddress.value ? (
              <UserAddressForm
                submitting={submitting}
                state={addressFormState}
                onSubmit={submit}
                buttonLabel={'登録する'}
              />
            ) : (
              <>
                <Alert>
                  <AlertContent
                    description={
                      <>
                        ご登録済みの住所の変更が必要な場合は、
                        <a
                          href="https://sheinc.notion.site/a64f420f1ae542eb8895c7383f0dc409"
                          target="_blank"
                          styleName="underline"
                        >
                          こちらのFAQ
                        </a>
                        ページをご確認ください
                      </>
                    }
                  />
                </Alert>
                <SummaryBody>
                  <UserAddressSummary userAddress={addressFormState.getDirtyValue()} />
                </SummaryBody>
              </>
            )}
          </SettingPane>
        );
      }
    }
  )
);
